import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FastfoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fastfood"}/>
}
